import React from "react";
import RentsetupForms from "./RentSetupForms";

const AddRentsetup = () => {

    return (
        <RentsetupForms type="Add" />
    )
}

export default AddRentsetup